export default __webpack_public_path__ + "static/sp-kv-2-a2026d5d1e369186f2315735a2fbc71f.png";